import React, {Component} from 'react';
import { Map, Marker, GoogleApiWrapper, Animation, BOUNCE, google, maps } from 'google-maps-react';




class ContactUs extends Component {
  render() {

    const style = {
      width: '90%',
      height: '433px',
      
      }    
    return (
        <div>
            <div>
  <div className="breadcrumb-banner-area" style={{backgroundImage: 'url(./img/service-header.png)'}}>
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="breadcrumb-text text-center">
            <h2>CONTACT US</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />
  <br />
  {/* breadcrumb-banner-area-end */}
  <div className="contact-area">
    <div className="container">
      <div className="row">
        <div className="col-md-6" style={{height: '480px'}}>
          {/* Google Map Start */}
          <div className="google-map-area">
            <div id="contacts" className="map-area">
              <div id="googleMap">

          <Map 
            google={this.props.google} 
            zoom={11}
            styles= {[{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]}
            initialCenter={{
            lat: 41.0270994,
            lng: -73.7641128
            }}
           
            style={style}>

            <Marker 
              icon={{
                url: "./img/map-marker.png"      
              }}
              animation= {this.props.google.maps.Animation.BOUNCE}
            />
          
           </Map>
           </div>
           </div>
           </div>
          <br />
          <br />
          {/* Google Map End */}
        </div>
        <div className="col-md-6">
          <h4>GET IN TOUCH</h4>
          <form id="contact-form" action="mail.php" method="post">
            <div className="row">
              <div className="col-md-6">
                <input type="text" name="name" id="name" placeholder="Your Name*" required/>
              </div>
              <div className="col-md-6">
                <input type="text" name="email" id="email" placeholder="Mail*" required />
              </div>
            </div>
            <div className="col-12 px-0">
            <input type="text" name="subject" id="subject" placeholder="Subject*"  required/>
            </div>
            <div className="col-12 px-0">
            <textarea name="message" id="message" cols="30" rows="10" placeholder="Type Your Message......." defaultValue={""} required/>
            </div>
            
            <button type="submit" className="default-btn submit-btn">SEND</button>
            <p className="form-messege" />
          </form>
        </div>
      </div>
    </div>
  </div>
  <div className="contact-section">
    <div className="container">
      <div className="row">
        <div className="col-lg-4 col-md-12">
          <div className="testimonial">
            <div className="quote single-contact-adrs">
              <span className="c-address-icon">
                <i className="fas fa-map-marker-alt" />
              </span>
            </div>
            <div className="adrs-text">
              <span>New York 235 Mamaroneck Ave, Suite #301, White Plains, 
                <br />NY 10605</span>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-12">
          <div className="testimonial">
            <div className="quote single-contact-adrs">
              <span className="c-address-icon">
                <i className="fas fa-phone" />
              </span>
            </div>
            <div className="adrs-text">
              <span>+1 (914) 615-9170
              </span>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-md-12">
          <div className="testimonial">
            <div className="quote single-contact-adrs">
              <span className="c-address-icon">
                <i className="fas fa-globe" />
              </span>
            </div>
            <div className="adrs-text">
              <span>info@techarabiya.com</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

        </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: ('AIzaSyCjkssBA3hMeFtClgslO2clWFR6bRraGz0')
 })(ContactUs);